import { Component } from '@angular/core';

@Component({
  selector: 'hdw-about-migrants-tool',
  templateUrl: './about-migrants-tool.component.html',
  styleUrls: ['./about-migrants-tool.component.scss']
})
export class AboutMigrantsToolComponent {}
